import { render } from "./SubstituteUsers.vue?vue&type=template&id=d883ba7a"
import script from "./SubstituteUsers.vue?vue&type=script&lang=js"
export * from "./SubstituteUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__